import ImageWithFallback from '@/components/shared/ImageWithFallback';
import Loading from '@/components/shared/Loading';
import { Skeleton } from '@/components/ui/skeleton';
import { useSession } from '@/contexts/LitSessionProvider';
import useAuthGuard from '@/hooks/auth/useAuthGuard';
import useReferralCode from '@/hooks/onboarding/useReferralCode';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import useGetAllTimePnL from '@/hooks/portfolio/useGetAllTimePnL';
import classNames from '@/lib/misc/classNames';
import { toSpecialFixed } from '@/lib/misc/utils';
export default function PortfolioOverview() {
  const {
    isUserWithFunds
  } = useAuthGuard();
  const {
    isLoading: isLoadingPnlData,
    data
  } = useGetAllTimePnL();
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const {
    referralData
  } = useReferralCode();
  const currentBalance = assetData?.totalUsdValue;
  const pnlData = data?.pnlData;
  const statsData = data?.statsData;
  const realized_pnl_percent = pnlData?.totals?.realised_pnl ? pnlData?.totals?.realised_pnl / pnlData?.totals?.buy_value * 100 : 0;
  const createdAt = new Date(statsData?.created_at);
  const daysAgo = (new Date().getTime() - createdAt?.getTime()) / (1000 * 60 * 60 * 24);
  const hoursAgo = daysAgo % 24;
  const timeAgoString = `${Math.floor(daysAgo)} days, ${Math.floor(hoursAgo)} hours ago`;
  const isOverviewLoading = (isLoadingPnlData || isLoadingAssetData) && !currentBalance && !pnlData;
  return <>
      {isOverviewLoading ? <div className=' flex items-center justify-between w-full'>
          <Loading className='mt-12' />
        </div> : <div className='flex justify-between w-full'>
          {isUserWithFunds ? <div className='text-[14px] leading-6 w-full'>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Genius points</p>
                <div className='blur-[4px]'>
                  <p className='text-genius-cream'>$1000</p>
                </div>
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Amount Invested</p>
                <p>${toSpecialFixed(pnlData?.totals?.buy_value, 2)?.value}</p>
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Current Balance</p>
                <p>${toSpecialFixed(currentBalance, 2)?.value}</p>
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>All Time Realized Returns</p>
                {isNaN(parseFloat(pnlData?.totals?.realised_pnl)) ? <>
                    <Skeleton className='w-20 h-4' />
                  </> : <>
                    <p className={classNames(realized_pnl_percent < 0 ? 'text-red-400' : 'text-green-400', 'ta-r')}>
                      {('$' + toSpecialFixed(parseFloat(pnlData?.totals?.realised_pnl), 2).value).replace('$-', '- $')}{' '}
                      ({toSpecialFixed(realized_pnl_percent, 2)?.value}%)
                    </p>
                  </>}
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Current Unrealized Returns</p>
                {isNaN(parseFloat(pnlData?.totals?.unrealised_pnl)) ? <>
                    <Skeleton className='w-20 h-4' />
                  </> : <>
                    <p className={`
                ${pnlData?.totals?.unrealised_pnl < 0 ? `text-red-400` : `text-green-400`}
                ta-r`}>
                      {('$' + toSpecialFixed(parseFloat(pnlData?.totals?.unrealised_pnl), 2).value).replace('$-', '- $')}{' '}
                      ({toSpecialFixed(pnlData?.totals?.unrealized_pnl_percent, 2)?.value}
                      %)
                    </p>
                  </>}
              </div>
              {/* <div className='flex items-center justify-between'>
               <p className='text-genius-cream/50'>Today's Unrealized Returns</p>
               <p className='text-green-400 ta-r'>$160.21 (7.5%)</p>
               </div> */}
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Total # of Trades</p>
                <p className='ta-r'>{statsData?.successful_order_count}</p>
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50 ta-r'>Total Trading Volume</p>
                <p>${toSpecialFixed(pnlData?.totals?.total_volume, 2)?.value}</p>
              </div>

              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50 ta-r'>Total Referral Trading Volume</p>
                <p>
                  $
                  {referralData && referralData?.totalReferralVolume ? toSpecialFixed(referralData?.totalReferralVolume?.totalVolume, 2).value : '0'}
                </p>
              </div>
              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Total # of Referrals</p>
                <p className='ta-r'>{referralData?.codes?.times_used}</p>
              </div>

              <div className='flex items-center justify-between'>
                <p className='text-genius-cream/50'>Account Age</p>
                <p className='ta-r'>{timeAgoString}</p>
              </div>
            </div> : <div className='h-full w-full flex flex-col items-center gap-4 justify-center p-4'>
              <ImageWithFallback src='/icons/nothingcircle.png' alt='nothing icon' width={80} height={80} />
              <p className='text-genius-cream/50 text-[20px]'>Nothing here, yet</p>
            </div>}
        </div>}
    </>;
}